module.exports = __webpack_public_path__ + "static/media/battery-banesco.fdde6ee7.svg";